import { render, staticRenderFns } from "./FeaturesBlock.vue?vue&type=template&id=d2883052&scoped=true&"
import script from "./FeaturesBlock.vue?vue&type=script&lang=ts&"
export * from "./FeaturesBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturesBlock.vue?vue&type=style&index=0&id=d2883052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2883052",
  null
  
)

export default component.exports